export var ENTITY = "general-ledger-account";
export var REDUCER_KEY = "GENERAL_LEDGER_ACCOUNT_V2";
export var BASE_PATH_ENTITY = "general-ledger-accounts";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
